import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { SunIcon, MoonIcon, Bars3Icon } from '@heroicons/react/24/outline';

const Header: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="navy-gradient shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo and title */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-12 h-12 bg-gold-950 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-xl">NFB</span>
            </div>
            <div className="text-white">
              <h1 className="text-xl font-bold">Navy Football Brotherhood</h1>
              <p className="text-gray-300 text-sm">v2.0</p>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/"
              className="text-white hover:text-gold-500 transition-colors duration-200"
            >
              Home
            </Link>
            
            {isAuthenticated && (
              <>
                <Link
                  to="/members"
                  className="text-white hover:text-gold-500 transition-colors duration-200"
                >
                  Members
                </Link>
                <Link
                  to="/seats"
                  className="text-white hover:text-gold-500 transition-colors duration-200"
                >
                  Seats
                </Link>
                <Link
                  to="/profile"
                  className="text-white hover:text-gold-500 transition-colors duration-200"
                >
                  Profile
                </Link>
                {user?.isAdmin && (
                  <Link
                    to="/admin"
                    className="text-white hover:text-gold-500 transition-colors duration-200"
                  >
                    Admin
                  </Link>
                )}
              </>
            )}
          </nav>

          {/* Right side actions */}
          <div className="flex items-center space-x-4">
            {/* Theme toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-200"
              aria-label="Toggle theme"
            >
              {isDark ? (
                <SunIcon className="w-5 h-5 text-white" />
              ) : (
                <MoonIcon className="w-5 h-5 text-white" />
              )}
            </button>

            {/* Auth buttons */}
            {isAuthenticated ? (
              <div className="flex items-center space-x-3">
                <span className="text-white text-sm">
                  Welcome, {user?.firstName}
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                >
                  Logout
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Link
                  to="/login"
                  className="text-white hover:text-gold-500 transition-colors duration-200"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn-secondary"
                >
                  Register
                </Link>
              </div>
            )}

            {/* Mobile menu button */}
            <button className="md:hidden p-2 text-white">
              <Bars3Icon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
